import { AlertIcon } from '@atgfr8/icons';

export const ErrorPill = (props: { text: string }) => {
  return (
    <div
      class="
        px-1 mx-1 my-1 w-fit rounded-md
        ring-4 ring-red-500
        shadow-xl shadow-red-500/50
        font-semibold text-sm
        flex items-center gap-x-2
    "
    >
      <AlertIcon color="#ef4444 " />
      <div>{props.text}</div>
    </div>
  );
};
